module.exports = __webpack_public_path__ + "img/Greece 2.0_NextGeneration_en 1.3392573a.png";